import { useEffect } from 'react';
import { FormProvider, useFormContext } from 'react-hook-form';

import Button from 'components/field/Button';
import Alert from 'components/global/Alert';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import useAlert from 'hooks/useAlert';

import { openAxios } from 'services/axios';
import { OTO_LINK } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import { faCreditCardFront, faMoneyBill1 } from '@fortawesome/pro-light-svg-icons';

import { FormHeader } from '../OTOLinkBuyer';
import * as S from './Tabs.styled';

const validateOptions = {
	shouldValidate: true,
	shouldDirty: true
};

const SelectPaymentMethodTab = ({ nextStep, prevStep }) => {
	const { showError } = useAlert();

	const formMethods = useFormContext();
	const {
		handleSubmit,
		setValue,
		watch,
		reset,
		formState: { isSubmitting, isDirty, isValid }
	} = formMethods;

	const onSubmit = async (data) => {
		try {
			const response = await openAxios.post(OTO_LINK.UPDATE_OTO_LINK_BUYER_PAYMENT_METHOD, {
				key: data.key,
				GUID: data.GUID,
				otoLinkSessionId: data.otoLinkSessionId,
				paymentMethod: data.paymentMethod
			});
			if (response.status !== 200) {
				throw new Error(response);
			}
			reset(data);
			nextStep();
		} catch (error) {
			AppLogger.error(error);
			showError();
		}
	};

	const allowedPaymentMethods = watch('allowedPaymentMethods');

	useEffect(() => {
		if (allowedPaymentMethods !== 'BOTH') {
			setValue('paymentMethod', allowedPaymentMethods, validateOptions);
		}
	}, [allowedPaymentMethods]);

	return (
		<FormProvider {...formMethods}>
			<S.Card padding={0} background border={0} shadowed rounded>
				<S.Wrapper>
					<div>
						<FormHeader
							title="selectPaymentMethod"
							className="section-padding-bottom"
							onClick={() => prevStep()}
						/>
						{['COD', 'CC'].includes(allowedPaymentMethods) && (
							<Alert
								content="otoLinkSellerConfiguredPaymentMethod"
								variant="warning"
								className="section-margin-bottom"
								showIcon
							/>
						)}
						<S.PaymentContainer className="section-padding-bottom">
							{['COD', 'BOTH'].includes(allowedPaymentMethods) && (
								<S.PaymentTypeButton
									disabled={allowedPaymentMethods === 'COD'}
									onClick={() => setValue('paymentMethod', 'COD', validateOptions)}
									className={watch('paymentMethod') === 'COD' && 'selected'}>
									<Icon icon={faMoneyBill1} size="x-large" color="#183153" />
									<Typography fontWeight="500">cod</Typography>
								</S.PaymentTypeButton>
							)}
							{['CC', 'BOTH'].includes(allowedPaymentMethods) && (
								<S.PaymentTypeButton
									disabled={allowedPaymentMethods === 'CC'}
									onClick={() => setValue('paymentMethod', 'CC', validateOptions)}
									className={watch('paymentMethod') === 'CC' && 'selected'}>
									<Icon icon={faCreditCardFront} size="x-large" color="#183153" />
									<Typography fontWeight="500">creditCard</Typography>
								</S.PaymentTypeButton>
							)}
						</S.PaymentContainer>
					</div>

					<S.FormRow id="confirm-form">
						<Button
							label="continue"
							variant="blue"
							fullWidth
							onClick={handleSubmit(onSubmit, (errors) => {
								AppLogger.log(errors);
							})}
							disabled={isValid ? false : !isDirty}
							loading={isSubmitting}
							size="xx-large"
						/>
					</S.FormRow>
				</S.Wrapper>
			</S.Card>
		</FormProvider>
	);
};

export default SelectPaymentMethodTab;
